/**
 * Hook to access current user's role from Clerk metadata
 */

import { useUser } from '@clerk/clerk-react';
import { UserRole } from '../types/roles';

interface UseUserRoleReturn {
  role: UserRole;
  isAdmin: boolean;
  isClient: boolean;
  isLoading: boolean;
}

export function useUserRole(): UseUserRoleReturn {
  const { user, isLoaded } = useUser();

  // Extract role from publicMetadata
  const role: UserRole = 
    (user?.publicMetadata?.role as UserRole) || 'client';

  return {
    role,
    isAdmin: role === 'admin',
    isClient: role === 'client',
    isLoading: !isLoaded
  };
}

